import { createSlice } from '@reduxjs/toolkit'
import { FirestoreDatabase } from '../index'
import { Collection } from 'constants/index'
import { signOut } from 'store/auth'

export const initialState = {
  error: null,
  inProgress: false,
  settings: null
}

const settingSlice = createSlice({
  name: 'setting',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setSettings: (state, action) => {
      state.settings = action.payload
    },
    setSetting: (state, action) => {
      state.settings = {
        ...state.settings,
        ...action.payload
      }
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.settings = null
    }
  }
})

export const fetchSettings = (id) => async (dispatch) => {
  try {
    dispatch(settingSlice.actions.setProgress(true))
    const snapshot = await FirestoreDatabase.collection(Collection.SETTINGS).doc(id).get()
    dispatch(
      settingSlice.actions.setSettings({
        id: snapshot.id,
        ...snapshot.data()
      })
    )
  } catch (err) {
    dispatch(settingSlice.actions.setError(err))
  } finally {
    dispatch(settingSlice.actions.setProgress(false))
  }
}

export const updateSettingById = (id, payload, onSuccess, onError) => async (dispatch) => {
  try {
    await FirestoreDatabase.collection(Collection.SETTINGS)
      .doc(id)
      .set(
        {
          ...payload
        },
        { merge: true }
      )
    dispatch(settingSlice.actions.setSetting(payload))
    if (onSuccess) onSuccess()
  } catch (err) {
    dispatch(settingSlice.actions.setError(err))
    if (onError) onError(err)
  }
}

export default settingSlice
